import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { TableType } from 'src/shared/enums';

// TODOC :: check if can unify with main app component
@Component({
    standalone: false,
    selector: 'import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.scss']

})
export class ImportComponent implements OnInit, OnDestroy {
    private readonly topLevelImportTabs = ['zone-descriptions', 'calibration-set-table-field-attributes'];
    private readonly tabChangeSubject = new BehaviorSubject<string | null>(null);
    private readonly subTabChangeSubject = new BehaviorSubject<string | null>(null);
    private subscriptions: Subscription[] = [];

    readonly currentTab = this.tabChangeSubject.asObservable().pipe(distinctUntilChanged());
    readonly currentSubTab = this.subTabChangeSubject.asObservable().pipe(distinctUntilChanged());

    tableType: any = TableType;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly location: Location,
    ) {}

    ngOnInit() {
        this.mapTabToRouter();
        this.subscriptions.push(
            this.router.events
                .pipe(filter(event => event instanceof NavigationEnd))
                .subscribe(() => this.mapTabToRouter())
        );

        this.subscriptions.push(
            combineLatest([this.currentTab, this.currentSubTab])
                .pipe(
                    map(([tab, subTab]) => {
                        const pathParts = this.location.path().split('/').filter(Boolean);
                        const tabName = pathParts[pathParts.length - 2] || null;
                        const routeTail = pathParts[pathParts.length - 1] || '';
                        const isTopLevelImportTab = this.topLevelImportTabs.includes(routeTail);
                        return [tab || (isTopLevelImportTab ? routeTail : tabName), subTab || ''];
                    }),
                    filter(([tab]) => tab !== null),
                    distinctUntilChanged()
                )
                .subscribe(([tab, subTab]) => {
                    // TODO :: this appears to be problem, need to do something with this.
                    if (this.location.path().includes('import')) {
                        const token = this.route.snapshot.paramMap.get('token');
                        this.tabChangeHandler(tab);
                        this.subTabChangeHandler(subTab);
                        if (this.topLevelImportTabs.includes(tab)) {
                            this.router.navigate([`/import/zoning-code/${token}/${tab}`]);
                            return;
                        }
                        this.router.navigate([`/import/zoning-code/${token}/${tab}/${subTab}`]);
                    }
                })
        );
    }

    tabChangeHandler(tabName: string) {
        if (this.tabChangeSubject.value !== tabName) {
            this.subTabChangeSubject.next(null);
        }
        this.tabChangeSubject.next(tabName);
    }

    subTabChangeHandler(subTabName: string) {
        this.subTabChangeSubject.next(subTabName);
    }

    private mapTabToRouter() {
        const pathParts = this.location.path().split('/').filter(Boolean);
        const routeTail = pathParts[pathParts.length - 1] || '';
        const tabName = pathParts[pathParts.length - 2] || null;

        if (this.topLevelImportTabs.includes(routeTail)) {
            this.tabChangeSubject.next(routeTail);
            this.subTabChangeSubject.next('');
            return;
        }

        this.tabChangeSubject.next(tabName);
        this.subTabChangeSubject.next(routeTail);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => !subscription.closed && subscription.unsubscribe());
    }
}
